import React from 'react';
import {
  AhaEditorUtils,
  useSlateStatic,
  type AhaReferenceElement,
} from '@aha-app/aha-editor-v2';
import ReferenceAhaKnowledgeBaseLink from './ReferenceAhaKnowledgeBaseLink';
import { ReferenceAhaPill } from './ReferenceAhaPill';
import type BatchedRecordLoader from '../../../../framework/BatchedRecordLoader';

interface ReferenceAhaElementProps {
  batchedRecordLoader: BatchedRecordLoader;
  isModifiable: boolean;
  element: AhaReferenceElement;
}

const ReferenceAhaElement = ({
  batchedRecordLoader,
  element,
  isModifiable,
}: ReferenceAhaElementProps) => {
  const editor = useSlateStatic();
  const onUpdateReferenceOptions = ({ visibleFields }) => {
    if (!editor) return;

    AhaEditorUtils.Transforms.setNodeByElement<AhaReferenceElement>(
      editor,
      element,
      { reference_visibleFields: visibleFields }
    );
  };

  return (
    <>
      {window.isKnowledgeBase && window.knowledgeBasePageData ? (
        <ReferenceAhaKnowledgeBaseLink element={element} />
      ) : (
        <ReferenceAhaPill
          batchedRecordLoader={batchedRecordLoader}
          element={element}
          isModifiable={isModifiable}
          onUpdateReferenceOptions={onUpdateReferenceOptions}
        />
      )}
    </>
  );
};

export default ReferenceAhaElement;
